/* ============================================================
   The Money–Body Code — sales-page.js
   Page-global behaviour for the sales page (templates/
   product.the-money-body-code.json). Loaded once from
   layout/theme.liquid. Ported verbatim from
   preview/sales-page.html's closing <script> block.

   Section-local behaviour (S8 phone/audio, S8b tab panel,
   S12 accordion, Hallway 12 breath spiral) lives in each
   section's own {% javascript %} block.
   ============================================================ */

/* Film grain — full-viewport fixed canvas (#grain) */
(function () {
  var canvas = document.getElementById('grain');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var frame = 0, w, h, buf;
  function resize() {
    w = canvas.width  = window.innerWidth;
    h = canvas.height = window.innerHeight;
    buf = ctx.createImageData(w, h);
  }
  function tick() {
    if (frame % 3 === 0) {
      var d = buf.data;
      for (var i = 0; i < d.length; i += 4) {
        var v = (Math.random() * 255) | 0;
        d[i] = d[i+1] = d[i+2] = v; d[i+3] = 255;
      }
      ctx.putImageData(buf, 0, 0);
    }
    frame++;
    requestAnimationFrame(tick);
  }
  resize();
  window.addEventListener('resize', resize);
  requestAnimationFrame(tick);
})();

/* Scroll-reveal — fades/slides .hl-reveal elements in as they enter view */
(function () {
  var els = document.querySelectorAll('.hl-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.18 });
  els.forEach(function (el) { obs.observe(el); });
})();

/* S13 CTA — one-time specular sweep when it scrolls into view */
(function () {
  var btn = document.querySelector('.s13-cta-button');
  if (!btn) return;
  if (!('IntersectionObserver' in window)) { btn.classList.add('swept'); return; }
  var o = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { btn.classList.add('swept'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.6 });
  o.observe(btn);
})();

/* Ambient gold light particles (same physics as the homepage offer section) —
   shared across any section with a `.gold-particles` canvas + data-count */
(function () {
  var canvases = document.querySelectorAll('.gold-particles');
  if (!canvases.length) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var R = 226, G = 191, B = 106; // gold

  function initGoldParticles(canvas) {
    var section = canvas.closest('section');
    if (!section) return;
    var ctx = canvas.getContext('2d');
    var COUNT = parseInt(canvas.dataset.count || '23', 10);
    var w, h, parts;

    function init() {
      w = canvas.width = section.clientWidth || 600;
      h = canvas.height = section.clientHeight || 400;
      parts = [];
      for (var i = 0; i < COUNT; i++) {
        parts.push({
          x: Math.random() * w, y: Math.random() * h,
          size: Math.random() * 2 + .5,
          sy: -(Math.random() * .13 + .035),
          sx: (Math.random() - .5) * .05,
          op: Math.random() * .45 + .15,
          ph: Math.random() * Math.PI * 2,
          ps: Math.random() * .012 + .003
        });
      }
    }

    function frame() {
      ctx.clearRect(0, 0, w, h);
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        p.x += p.sx; p.y += p.sy; p.ph += p.ps;
        var a = p.op * (Math.sin(p.ph) * .15 + .85);
        if (p.y < -10) { p.y = h + 10; p.x = Math.random() * w; }
        if (p.x < -10) p.x = w + 10;
        if (p.x > w + 10) p.x = -10;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(' + R + ',' + G + ',' + B + ',' + a + ')';
        ctx.fill();
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size * 3);
        g.addColorStop(0, 'rgba(' + R + ',' + G + ',' + B + ',' + (a * .3) + ')');
        g.addColorStop(1, 'rgba(' + R + ',' + G + ',' + B + ',0)');
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size * 3, 0, Math.PI * 2);
        ctx.fillStyle = g;
        ctx.fill();
      }
      requestAnimationFrame(frame);
    }

    init();
    if (!reduceMotion) frame();
    window.addEventListener('resize', init);
  }

  canvases.forEach(initGoldParticles);
})();
